import type { PricesByPaymentMethods } from 'types/api/prices';
import type { ProductType, ProductSubtype } from 'types/api/products/product';
import { InvoiceInfoType } from './invoice';

export enum PaymentStatus {
	Init = 'init',
	None = 'none',
	Pending = 'pending',
	Succeed = 'succeed',
	Failed = 'failed'
}

export enum ConfirmationStatus {
	Succeed = 'succeed',
	Waiting = 'waiting',
	Pending = 'pending'
}

export enum RecurringGatewayType {
	Card = 'card_recurring',
	Blik = 'blik_recurring'
}

export enum PaymentMethod {
	Bluemedia = 'bluemedia',
	Bluemedia_Subscription = 'subscription_bluemedia',
	PacketsSubscription = 'packets_subscription',
	Invoice = 'invoice'
}

export type VoucherPromotionPrices = {
	prices_by_payment_methods: PricesByPaymentMethods;
};

export type PaymentEnoughCreditsResponse = {
	credits_enough: boolean;
};

export type PaymentInitResponse = {
	credits_enough: boolean;
};

export type PaymentBuyResponse = {
	PaymentId: number;
	RedirectUrl: string;
	Status: string;
};

export type TransactionDetails = {
	id: number;
	product_uuid: string;
	user_id: number;
	user_login: string;
	final_price: number;
	period: number;
	payment_method: PaymentMethod;
	status: PaymentStatus;
	created_at: string;
	product_title: string;
	product_type: ProductType | 'payment_activation';
	product_subtype: ProductSubtype;
	base_price: number;
	price_entry_id: number;
	promotion_id: number | null;
	promotion_type: string | null;
	promotion_value: number | null;
	account_id: string;
	updated_at: string;
	system: string;
	platform: string;
	stb_id: string | null;
	gateway_type: string;
	need_invoice: number;
	recurring_activation: boolean;
	data: InvoiceInfoType | null;
	device_id: string;
	confirmed: boolean;
	withdrawn: boolean;
	user_product_id: number | null;
	used_promotion_id: number | null;
	adult: boolean | null;
	aff_code: string | null;
	redirect_url: string | null;
	confirmation_status: ConfirmationStatus;
};

export type SavedPaymentData = {
	id: number;
	card_issuer: 'VISA' | 'MASTERCARD';
	card_mask: string;
	expiration_date: string;
	gateway_type: RecurringGatewayType;
	created_at: string;
	updated_at: string;
};

export type LastPaymentsRedirectUrl = {
	payment_id: number;
	redirect_url: string;
	title: string;
	status: PaymentStatus.Pending | PaymentStatus.Failed;
};

export type LastPayments = {
	vod_redirect_url: LastPaymentsRedirectUrl | null;
	packet_redirect_url: LastPaymentsRedirectUrl | null;
};

export type LastPaymentsResponse = {
	status: string;
	data: LastPayments;
};
